import React from "react";
import { useQuery } from "@apollo/client";

import {
  GetJoinRequestAggregateResult,
  getJoinRequestAggregateForVF,
} from "../../graphqlQueries/getJoinRequests";
import { UserRole } from "../../types";
import { getHasuraRoleContext } from "../../utils/functions";
import NavigationMenuLink from "./NavigationMenuLink";

const DashboardLinkWithJoinRequestNotification = ({ to }: { to: string }) => {
  const { data: newJoinRequests } = useQuery<GetJoinRequestAggregateResult>(
    getJoinRequestAggregateForVF,
    {
      context: getHasuraRoleContext(UserRole.ManageDatahub),
    }
  );

  const showNotification =
    newJoinRequests && newJoinRequests.companyJoinRequestAggregate.aggregate.count > 0;

  return (
    <NavigationMenuLink
      to={to}
      i18n="navigation.dashboard"
      icon="home"
      showNotificationIcon={showNotification}
    />
  );
};

export default DashboardLinkWithJoinRequestNotification;
